export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2d-7a3d84da443a4f3deda5fc7e6155d93a.webp";